module.exports = __webpack_public_path__ + "static/media/29BDOS5.288490cd.jpg";